"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Slider = _interopRequireDefault(require("./Slider/Slider"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _TextWithSyllabification = _interopRequireDefault(require("../TextWithSyllabification/TextWithSyllabification"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.articleBox-container {\n  padding-top: 0px;\n  max-width: 100%;\n  width: 510px;\n  box-sizing: content-box;\n  height: 100%;\n  position: relative; }\n  .articleBox-container h3 {\n    margin: 0px;\n    max-width: 90%; }\n  .articleBox-container .subtext {\n    letter-spacing: 0.32px; }\n  .articleBox-container .link {\n    cursor: pointer;\n    width: fit-content; }\n  .articleBox-container .main-tag-no-image {\n    background-color: #fff;\n    color: #000000;\n    border-radius: 12px;\n    padding: 4px 8px 0px 8px;\n    border: 1px solid #000000;\n    width: fit-content;\n    height: 24px; }\n  .articleBox-container .themen_tags {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap; }\n    .articleBox-container .themen_tags .themen-tag-no-image {\n      background-color: #fff;\n      color: #000000;\n      border-radius: 12px;\n      padding: 4px 8px 0px 8px;\n      border: 1px solid #000000;\n      width: fit-content;\n      height: 24px; }\n  .articleBox-container .themen_tags-image {\n    top: 8px;\n    left: 8px;\n    position: absolute;\n    z-index: 5;\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap; }\n  .articleBox-container .slick-slide {\n    aspect-ratio: 1.7 !important; }\n\n.articleBox-container.one-column {\n  width: 239px; }\n\n@media (max-width: 852px) {\n  .articleBox-container {\n    width: 240px; }\n    .articleBox-container .main-tag-no-image {\n      top: 0px;\n      left: 0px; } }\n";
  const fileName = "ArticleBox_ArticleBox";
  const element = document.querySelector("style[data-sass-component='ArticleBox_ArticleBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MAX_DESCRIPTION = 225;
const ArticleBox = _ref => {
  let {
    article_lead,
    title,
    isOneColumn,
    author,
    date,
    lang,
    alias,
    pictures_gallery,
    main_tag,
    article_type,
    isLastInRow,
    isFirstInRow,
    image_external_url,
    url,
    lead
  } = _ref;
  const lead_value = lead === 'NULL' ? '' : lead || article_lead || '';
  const isLongDescription = lead_value?.length > MAX_DESCRIPTION;
  const description = `${lead_value?.length > 0 ? lead_value?.slice(0, MAX_DESCRIPTION)?.trim() : ''}${isLongDescription ? '...' : ''}`;
  const media = image_external_url && image_external_url?.length > 0 ? [{
    src: image_external_url,
    type: 'IMAGE'
  }] : pictures_gallery?.map(picture => {
    return {
      src: picture[0]?.tablet?.url,
      type: 'IMAGE'
    };
  });
  const newDate = _react.default.useMemo(() => {
    const format = date?.split('-');
    if (format?.length !== 3) return '';
    const day = format[2][0] === '0' ? format[2].slice(1) : format[2];
    const month = format[1][0] === '0' ? format[1].slice(1) : format[1];
    const year = format[0];
    return `${day}.${month}.${year}`;
  }, [date]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `articleBox-container ${isOneColumn ? 'one-column' : ''} sia-margin-02-bottom ${!isLastInRow ? 'sia-margin-02-right' : ''} ${!isFirstInRow > 0 ? 'sia-padding-02-left sia-border-01-left' : ''}`
  }, media?.length > 0 && /*#__PURE__*/_react.default.createElement(_Slider.default, {
    items: [media[0]],
    autoplay: true,
    autoplaySpeed: 3000,
    main_tag: main_tag
  }), !(media?.length > 0) && main_tag && /*#__PURE__*/_react.default.createElement("div", {
    className: `main-tag-no-image sia-text-06`
  }, /*#__PURE__*/_react.default.createElement("span", null, main_tag)), /*#__PURE__*/_react.default.createElement("h3", {
    className: `sia-text-01 ${media?.length > 0 ? '' : 'sia-padding-02-top'}`
  }, article_type), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-12 sia-margin-01-top sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, {
    lang: lang
  }, title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-10 sia-margin-02-top"
  }, /*#__PURE__*/_react.default.createElement(_TextWithSyllabification.default, null, description)), /*#__PURE__*/_react.default.createElement("p", {
    className: "subtext sia-text-06 sia-margin-03-top sia-margin-03-bottom"
  }, author ? `${author} | ` : ``, newDate), alias && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "link",
    to: `/${lang}/cms${alias}`
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: "page-action-down-32"
  })), url && /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    className: "link",
    href: url
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: "page-action-down-32"
  })));
};
ArticleBox.propTypes = {
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    src: _propTypes.default.string.isRequired,
    srcTablet: _propTypes.default.string,
    srcMobile: _propTypes.default.string,
    type: _propTypes.default.string.isRequired,
    imagePlaceholder: _propTypes.default.string,
    copyright: _propTypes.default.object
  })),
  article_lead: _propTypes.default.string,
  title: _propTypes.default.string,
  page_lead: _propTypes.default.string,
  isOneColumn: _propTypes.default.bool,
  author: _propTypes.default.string,
  date: _propTypes.default.string,
  path: _propTypes.default.string,
  history: _propTypes.default.object,
  lang: _propTypes.default.string
};
ArticleBox.defaultProps = {};
var _default = exports.default = ArticleBox;